import { request } from './client.js';
// ── Flash-mode operator wrappers (§6.7 S4-UI) ───────────────────────────────
// Consumed by the PWA Flash-mode screen (apps/pwa/src/modules/flash). Both
// routes reuse `requireFlashCheckInActor` server-side (org_admin + supervisor
// + operator) — see event-batch-checkin.controller.ts / event-guest-match.controller.ts.
/** POST /events/:id/batch-checkin — R4.2/R4.3/R4.4 batch multi-vehicle check-in. */
export async function batchCheckIn(eventId, input) {
    return request(`/events/${encodeURIComponent(eventId)}/batch-checkin`, {
        method: 'POST',
        body: input,
    });
}
/**
 * GET /events/:id/guests/match?plate=&name= — R2.3/R2.4 plate-first,
 * name-fallback guest lookup. Never auto-stamps; the caller decides what to
 * do with `matched` / `ambiguous` / `candidates`.
 */
export async function matchEventGuest(eventId, query) {
    const params = new URLSearchParams();
    if (query.plate)
        params.set('plate', query.plate);
    if (query.name)
        params.set('name', query.name);
    const qs = params.toString();
    return request(`/events/${encodeURIComponent(eventId)}/guests/match${qs ? `?${qs}` : ''}`, { method: 'GET' });
}
//# sourceMappingURL=event-flash.js.map